<template>
<div class="chapter">
<div class="inner_page">
<div class="chap" id="ch02">
<p class="ct"><a class="xref" href="#/OEBPS/Text/pppstrangers005#toc">Chapter Two</a></p>
<p class="pf">Somewhere in St. Augustine, Florida, right this minute, someone is murdering history. It happens all the time.</p>
<p class="calibre4">When this city was founded, Elizabeth I was Queen of England. It was a single year after the death of Michelangelo, and the Renaissance had seized Europe with no intention of letting go. In other words, it was a very long time ago.</p>
<p class="calibre4">Since then, the Spanish built their city atop the site of a Native American village. Then the English came and went, and the Spanish came back. And now the Americans have held the land for nearly two centuries.</p>
<p class="calibre4">In St. Augustine, it is possible to drop your car keys and destroy something irreplaceable. Actually putting a shovel or a bulldozer blade into the soil…well, such activities are highly regulated.</p>
<p class="calibre4">Some people resent being told what to do. And some people are capable of doing bad things…evil things…when they have dollar signs in their eyes.</p>
<p class="calibre4">Somewhere in the countryside outside the old city, a bulldozer is scraping away the topsoil to build an upscale development. A human finger bone, a broken war club, a few musket balls, two pieces of a long stone blade, a corroded crucifix, a scattering of silver rosary beads, and a startling amount of very old trash—the discovery of these things causes the developer a moment of consternation, but only a moment. They are quickly discarded.</p>
<p class="calibre4">The man in charge has just one thing to say.</p>
<p class="calibre4">“What the historic preservation people don’t know won’t hurt ’em.”</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ppp-strangers010.vue?76c63b93